import type { usuarios as pt } from '../pt-BR/usuarios';
import type { Traducao } from '../Traducao';

export const usuarios = {
  titulo: 'Users and roles',
  descricao: 'Users who have already signed in to My Update and their roles.',
  filtros: {
    limpar: 'Clear all',
    rotulo: '{{filtro}}: {{valor}}',
    aplicados: 'Applied filters',
    remover: 'Remove filter {{filtro}}',
    botao: 'Filters',
    fechar: 'Close',
    perfis: { administrador: 'Administrator', profissional: 'Professional only' },
    entrou: { rotulo: 'Signed in to the system', sim: 'Yes', nao: 'No' },
  },
  porPagina: 'Items per page',
  semResultado: 'No users match these filters.',
  colunas: {
    nome: 'Name',
    email: 'Email',
    perfis: 'Roles',
    ultimoLogin: 'Last sign-in',
    cadastro: 'Axiis record',
    acoes: 'Actions',
  },
  nuncaEntrou: 'Never signed in',
  vinculo: {
    vinculado: 'Linked',
    sem_correspondencia: 'No match',
    duplicado: 'Duplicate',
    nao_verificado: 'Not checked',
  },
  acoes: { promover: 'Make administrator', rebaixar: 'Remove administrator' },
  confirmar: {
    promover: 'Make {{nome}} an administrator?',
    rebaixar: 'Remove the administrator role from {{nome}}? They remain a professional.',
  },
  promovido: '{{nome}} is now an administrator.',
  rebaixado: '{{nome}} is no longer an administrator.',
  vazio: 'No users found.',
} as const satisfies Traducao<typeof pt>;
